import { Header } from '@anytag/shared-molecules';
import { ExportButton } from './ExportButton';
import { ApproveButton } from './ApproveButton';

interface YoutubeCMSInvoicesHeaderProps {
  hasNoData?: boolean;
}

export const YoutubeCMSInvoicesHeader = ({ hasNoData }: YoutubeCMSInvoicesHeaderProps) => (
  <Header>
    <div css={{ display: 'flex', alignItems: 'center', gap: '4px', marginLeft: 'auto' }}>
      <ExportButton hasNoData={hasNoData} />
      <ApproveButton hasNoData={hasNoData} />
    </div>
  </Header>
);
